import React, { useEffect, useState } from 'react';
import Navbar from './global-components/navbar';
import PageHeader from './global-components/page-header';
import ProductDetails from './shop-components/shop-details';
// import CallToActionV1 from './section-components/call-to-action-v1';
import Footer from './global-components/footer';

const PropertyDetails = ({ match }) => {
  const [propertyData, setPropertyData] = useState(null);
  const [carrouselLinks, setCarrouselLinks] = useState([])

  useEffect(() => {
    const getPhotos = async () => {
      const response = await fetch(`https://f3mw4bb5.directus.app/items/propiedades_files?fields[]=directus_files_id&filter={"propiedades_id":"${match.params.propertyId}"}&page=1&limit=15`);
      const { data } = await response.json();
      const photosLink = data?.map(({ directus_files_id }) => `https://f3mw4bb5.directus.app/assets/${directus_files_id}`);
      setCarrouselLinks(photosLink)
      return Promise.resolve()
    }

    const getPropertyDeatils = async () => {
      const response = await fetch(`https://f3mw4bb5.directus.app/items/propiedades/${match.params.propertyId}`)
      const { data } = await response.json();
      setPropertyData(data);
      return Promise.resolve()
    }
// son las amenities
    Promise.all([getPhotos(), getPropertyDeatils()])
      .catch((error) => {
        console.log(error);
      })

  }, [match.params.propertyId])

  return <div>
    <Navbar />
    <PageHeader headertitle="Product Details" customclass="mb-0" />
    {/* {data?.carousel && <ProductSlider photosUri={data.carousel}/>} */}
    {/* <ProductSlider photos={carrouselLinks} /> */}
    <ProductDetails data={propertyData} carrouselLinks={carrouselLinks} />
    {/* <CallToActionV1 /> */}
    <Footer />
  </div>
}

export default PropertyDetails

